import { useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
  Tab,
  Box,
  TextField,
  Button,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

const TransactionLog = () => {
  const navigate = useNavigate();
  const [tab, setTab] = useState(0);

  // -------------------------
  // USER PRODUCTS TRANSACTIONS
  // -------------------------
  const [userTransactions] = useState([
    {
      id: 1,
      transactionId: "TXN1001",
      orderId: "ORD5501",
      productName: "Smart Watch",
      category: "Electronics",
      amount: 2599,
      status: "Completed",
      date: "2025-02-10",
    },
    {
      id: 2,
      transactionId: "TXN1002",
      orderId: "ORD5502",
      productName: "Wireless Earbuds",
      category: "Accessories",
      amount: 1299,
      status: "Pending",
      date: "2025-02-11",
    },
  ]);

  // -------------------------
  // SERVICE PROVIDER TRANSACTIONS
  // -------------------------
  const [serviceTransactions] = useState([
    {
      id: 1,
      transactionId: "SRV2001",
      serviceName: "Home Cleaning",
      category: "Household",
      amount: 499,
      status: "Completed",
      date: "2025-02-05",
    },
    {
      id: 2,
      transactionId: "SRV2002",
      serviceName: "Electrician Visit",
      category: "Repair",
      amount: 299,
      status: "Cancelled",
      date: "2025-02-06",
    },
  ]);

  // -------------------------
  // SUBSCRIPTION TRANSACTIONS
  // -------------------------
  const [subscriptionTransactions] = useState([
    {
      id: 1,
      transactionId: "SUB3001",
      subscriptionName: "Prime Membership",
      subscriptionFor: "Premium Tools",
      amount: 999,
      status: "Active",
      date: "2025-01-25",
    },
    {
      id: 2,
      transactionId: "SUB3002",
      subscriptionName: "Seller Boost Pack",
      subscriptionFor: "Add Product for recommendation",
      amount: 1499,
      status: "Expired",
      date: "2025-01-20",
    },
  ]);

  return (
    <>
      <div className="main_title">
        <h1>Transaction History</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> -
          Transaction History
        </p>
      </div>

      {/* -------------------- TABS -------------------- */}
      <Box className="custom_tabs1">
        <Tabs
          value={tab}
          onChange={(e, v) => setTab(v)}
          className="custom_tabs_links"
        >
          <Tab label="User Transactions" />
          <Tab label="Service Provider Transactions" />
          <Tab label="My Store Transactions" />
        </Tabs>
      </Box>

      {/* -------------------- TAB PANELS -------------------- */}

      {/* USER TRANSACTIONS TABLE */}
      {tab === 0 && (
        <div className="cards">
          <div className="table_header">
            <div className="left_s">
              <div className="form">
                <TextField
                  type="date"
                  InputLabelProps={{ shrink: true }}
                  size="small"
                />
              </div>
            </div>
            <div className="right_s">
              <Button  className="btn btn_primary">Export CSV</Button>
            </div>
          </div>

          <TableContainer className="table_container">
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Date</TableCell>
                  <TableCell>Transaction ID</TableCell>
                  <TableCell>Order ID</TableCell>
                  <TableCell>Product Name</TableCell>
                  <TableCell>Category</TableCell>
                  <TableCell>Amount</TableCell>
                  <TableCell>Status</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {userTransactions.map((t) => (
                  <TableRow hover key={t.id}>
                    <TableCell>{t.date}</TableCell>
                    <TableCell>{t.transactionId}</TableCell>
                    <TableCell>{t.orderId}</TableCell>
                    <TableCell>{t.productName}</TableCell>
                    <TableCell>{t.category}</TableCell>
                    <TableCell>₹{t.amount}</TableCell>
                    <TableCell>{t.status}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      )}

      {/* SERVICE PROVIDER TRANSACTIONS TABLE */}
      {tab === 1 && (
        <div className="cards">
          <div className="table_header">
            <div className="left_s">
              <div className="form">
                <TextField
                  type="date"
                  InputLabelProps={{ shrink: true }}
                  size="small"
                />
              </div>
            </div>
             <div className="right_s">
              <Button  className="btn btn_primary">Export CSV</Button>
            </div>
          </div>

          <TableContainer className="table_container">
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Date</TableCell>
                  <TableCell>Transaction ID</TableCell>
                  <TableCell>Service Name</TableCell>
                  <TableCell>Category</TableCell>
                  <TableCell>Amount</TableCell>
                  <TableCell>Status</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {serviceTransactions.map((t) => (
                  <TableRow hover key={t.id}>
                    <TableCell>{t.date}</TableCell>
                    <TableCell>{t.transactionId}</TableCell>
                    <TableCell>{t.serviceName}</TableCell>
                    <TableCell>{t.category}</TableCell>
                    <TableCell>₹{t.amount}</TableCell>
                    <TableCell>{t.status}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      )}

      {/* SUBSCRIPTION TRANSACTIONS TABLE */}
      {tab === 2 && (
        <div className="cards">
          <div className="table_header">
            <div className="left_s">
              <div className="form">
                <TextField
                  type="date"
                  InputLabelProps={{ shrink: true }}
                  size="small"
                />
              </div>
            </div>
             <div className="right_s">
              <Button  className="btn btn_primary">Export CSV</Button>
            </div>
          </div>

          <TableContainer className="table_container">
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Date</TableCell>
                  <TableCell>Transaction ID</TableCell>
                  <TableCell>Transaction Type</TableCell>
                  <TableCell>Amount</TableCell>
                  <TableCell>Status</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {subscriptionTransactions.map((t) => (
                  <TableRow hover key={t.id}>
                    <TableCell>{t.date}</TableCell>
                    <TableCell>{t.transactionId}</TableCell>
                    <TableCell>{t.subscriptionFor}</TableCell>
                    <TableCell>₹{t.amount}</TableCell>
                    <TableCell>{t.status}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      )}
    </>
  );
};

export default TransactionLog;
